module.exports = __webpack_public_path__ + "img/dirty-couch.7e050a2d.png";